(ns app.survey.view
  (:require
   [app.survey.form.view :as form]
   [app.survey.loading :as loading]
   [app.survey.login.view :as login]
   [app.survey.no-access :as no-access]
   [app.survey.routes :as routes]
   [app.survey.select-survey :as select-survey]
   [common.localization :as loc]
   [re-frame.core :as rf]))

(defn view
  []
  (let [route @(rf/subscribe [::routes/route])]
    (js/console.log "Render route " route)
    (case (:handler route)
      :form
      [form/view]
      :login
      [login/view]
      :loading
      [loading/view]
      :no-access
      [no-access/view]
      :select-survey
      [select-survey/view]
      [:div (loc/tr :not-found)])))
